import { getCompanion } from '../data/companions.js';
export function companionsOf(equipped, lookup) {
    const active = {};
    for (const slot of ['pet', 'mount']) {
        const templateId = equipped[slot]?.templateId;
        if (templateId === undefined)
            continue;
        const companionId = lookup(templateId)?.companion;
        if (companionId === undefined)
            continue;
        const definition = getCompanion(companionId);
        if (definition?.kind === slot)
            active[slot] = definition;
    }
    return active;
}
/**
 * Getting on takes a short summoning: the player stands still for this long,
 * and moving, fighting, casting or being hit breaks it off. Getting off is
 * instant. Short enough not to slow travel, long enough that a mount is not
 * an escape pressed in the middle of a fight.
 */
export const MOUNT_CAST_MS = 1_000;
/**
 * The mount actually under the player. Wearing one only makes it available:
 * the player gets on and off at will (`mount` intent), and a mount is for
 * travel — nobody fights from the saddle.
 */
export function riddenMount(active, riding) {
    return riding ? active.mount : undefined;
}
/**
 * Where a pet stands: always on the tile to its owner's right (east), so it
 * reads as a companion at their side rather than a follower lagging behind.
 * It is a cosmetic that never blocks nor gets hit, so the tile need not be
 * walkable; the pet steps there in lockstep with its owner.
 */
export function petPlace(owner) {
    return { x: owner.x + 1, y: owner.y };
}
/**
 * How far a pet reaches for what lies on the ground, in tiles around the
 * tile it stands on (a square, like melee range). Three covers a corpse's
 * loot, laid one ring around it, whichever side of its owner the kill fell,
 * without the pet sweeping a whole clearing.
 */
export const PET_FETCH_RADIUS = 3;
/**
 * How long a drop lies before a pet goes for it: long enough for the player
 * to see what fell (and its rarity's outline), short enough that the pet is
 * still worth having.
 */
export const PET_FETCH_DELAY_MS = 1_200;
/**
 * A pet that has strayed this far from its owner (in tiles, as a square)
 * gives up the errand and lands back at their side: an owner who walks away
 * does not leave it trotting behind across the map.
 */
export const PET_LEASH = 8;
/**
 * A fetching pet trots a little faster than its owner walks, so it catches
 * up with them on the way back.
 */
export const PET_FETCH_PACE = 0.75;
/** One tile from `from` towards `to`, diagonals allowed; `to` itself once next to it. */
export function petStep(from, to) {
    return { x: from.x + Math.sign(to.x - from.x), y: from.y + Math.sign(to.y - from.y) };
}
/** Whether a pet standing on `pet` fetches the drop lying on `drop`. */
export function petReaches(pet, drop) {
    return Math.max(Math.abs(pet.x - drop.x), Math.abs(pet.y - drop.y)) <= PET_FETCH_RADIUS;
}
//# sourceMappingURL=companions.js.map